import React from 'react';
import {showPopup} from 'app/utils/modals/ModalsService';
import PopupChangeAvatar from 'app/components/user/PopupChangeAvatar';
import {UserStore} from 'app/store/UserStore';
import {inject, observer} from 'mobx-react';
import I18n from 'app/i18n';
import {DEFAULT} from 'app/utils/Consts';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface Props {
    editAvatar?: boolean
    userStore?: UserStore
}

const AvatarEditorWithName = (props: Props): React.ReactNode => {
    const changeAvatar = () => (image: string) => props.userStore?.updateProfileImage(image);

    const openModalChangeAvatar = () => () => {
        showPopup('popup-change-avatar',
            () => <PopupChangeAvatar
                changeAvatar={changeAvatar()}
                popupId={'popup-change-avatar'}
                profile_image={profile_image ?? DEFAULT}
            />);
    };

    const {new_year_theme} = window.settings.config;
    const {editAvatar, userStore: {user}} = props;
    const {name, profile_image} = user ?? {};

    return <div className={`balance-user ${editAvatar ? 'balance-user--edit-avatar' : ''}`}>
        <div className="balance-user__icon">
            {profile_image && profile_image !== DEFAULT
                ? <img src={profile_image} alt="profile image" />
                : <SpriteIcon name={`#svg-account${new_year_theme ? '-santa' : ''}`} size={{height: 45, width: 45}} />
            }
            {editAvatar && <button
                className="balance-user__change-avatar"
                onClick={openModalChangeAvatar()}
            >
                {I18n.t('change')}
            </button>}
        </div>
        <span className="balance-user__name">{name}</span>
    </div>;
};

export default inject('userStore')(observer(AvatarEditorWithName));
